// Stub implementations for Firebase functions to allow project to run without Firebase
const noopAsync = async (...args) => { console.warn('Firebase function called but stubbed:', args); };
const noop = (...args) => { console.warn('Firebase function called but stubbed:', args); return {} };
export const query = noop;
export const collection = noop;
export const doc = noop;
export const getDocs = noopAsync;
export const getDoc = noopAsync;
export const addDoc = noopAsync;
export const setDoc = noopAsync;
export const updateDoc = noopAsync;
export const deleteDoc = noopAsync;
export const orderBy = noop;
export const where = noop;
export const serverTimestamp = noopAsync;
export const onSnapshot = noop;
// Additional helpers
